<button
  [class.show]="isVisible"
  class="btn-topo"
  (click)="scrollToTop()"
  aria-label="Voltar ao topo da página"
  title="Voltar ao topo"
>
  <i class="fa-solid fa-arrow-up" aria-hidden="true"></i>
</button>
